<template>
  <div class="working-days-dropdown" ref="dropdownRoot">
    <div class="btn-days">
      <button @click="togglePopover" class="dropdown-button"
        :style="{ fontSize: value.option.value === 'custom' ? '8px' : 'inherit' }">
        {{ getWorkingDaysDisplay(value) }}
      </button>
    </div>

    <div v-if="isOpen" ref="popover" @click.stop
      :class="dropdownPosition === 'top' ? 'popover-content-table-top' : 'popover-content-table-bottom'">
      <ul class="dropdwon-list">
        <li
          v-for="option in workingDaysOptions"
          :key="option.value"
          @click="selectOption(option, $event)"
          class="option-item"
        >
          {{ option.label }}
          <span v-if="tempSelection.option.value === option.value">✔️</span>
        </li>
      </ul>

      <div v-if="tempSelection.option.value === 'custom'" @click.stop>
        <div class="checkbox-columns">
          <div v-for="day in daysOfWeek" :key="day.value" class="cutom-input-container">
            <input
              type="checkbox"
              :id="`day-${day.value}`"
              :checked="tempSelection.customDays.includes(day.value)"
              @change="onCustomDayToggle(day.value)"
              class="custom-input"
            />
            <label :for="`day-${day.value}`">{{ day.label }}</label>
          </div>
        </div>
        <div style="text-align: right; margin-top: 3px;" class="button-paraent">
          <button @click="closeCustomPopover" class="btn-close">Close</button>
          <button @click="applySelection" class="btn-apply" :disabled="tempSelection.option.value === 'custom' && !tempSelection.customDays.length && !isFirstCustomToggle">Apply</button>
        </div>
      </div>

      <div v-else style="text-align: right; margin-top: 10px;" class="button-paraent">
        <button @click="closeCustomPopover" class="btn-close">Close</button>
        <button @click="applySelection" class="btn-apply">Apply</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkingDaysDropdown',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      dropdownPosition: 'bottom',
      workingDaysOptions: [
        { value: 'all', label: 'All days' },
        { value: 'except-weekend', label: 'Except weekend' },
        { value: 'except-sunday', label: 'Except Sunday' },
        { value: 'custom', label: 'Custom' }
      ],
      daysOfWeek: [
        { value: 'monday', label: 'Monday' },
        { value: 'tuesday', label: 'Tuesday' },
        { value: 'wednesday', label: 'Wednesday' },
        { value: 'thursday', label: 'Thursday' },
        { value: 'friday', label: 'Friday' },
        { value: 'saturday', label: 'Saturday' },
        { value: 'sunday', label: 'Sunday' }
      ],
      tempSelection: {
        option: { value: '', label: '' },
        customDays: []
      },
      isFirstCustomToggle: true
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.tempSelection = {
      option: { ...this.value.option },
      customDays: [...(this.value.customDays || [])]
    };
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    togglePopover(event) {
      if (event) event.stopPropagation();
      this.$nextTick(() => {
        const rect = this.$el.getBoundingClientRect();
        const dropdownHeight = 250;
        const spaceBelow = window.innerHeight - rect.bottom;
        this.isOpen = !this.isOpen;
        this.dropdownPosition = spaceBelow < dropdownHeight ? 'top' : 'bottom';
        if (this.isOpen) {
          this.tempSelection = {
            option: { ...this.value.option },
            customDays: [...(this.value.customDays || [])]
          };
          this.isFirstCustomToggle = true;
        }
      });
    },
    selectOption(option, event) {
      if (event) event.stopPropagation();
      let customDays = [...this.tempSelection.customDays];

      if (option.value === 'custom') {
        if (this.tempSelection.option.value === 'custom') {
          this.tempSelection = {
            option: { value: '', label: '' },
            customDays: [...this.value.customDays]
          };
          this.isFirstCustomToggle = true;
          return;
        }
        this.isFirstCustomToggle = true;
      } else {
        switch (option.value) {
          case 'all':
            customDays = this.daysOfWeek.map(day => day.value);
            break;
          case 'except-weekend':
            customDays = this.daysOfWeek
              .filter(day => day.value !== 'saturday' && day.value !== 'sunday')
              .map(day => day.value);
            break;
          case 'except-sunday':
            customDays = this.daysOfWeek
              .filter(day => day.value !== 'sunday')
              .map(day => day.value);
            break;
        }
        this.isFirstCustomToggle = true;
      }
      this.tempSelection = { option, customDays };
    },
    onCustomDayToggle(dayValue) {
      let customDays = [...this.tempSelection.customDays];
      const index = customDays.indexOf(dayValue);

      if (this.isFirstCustomToggle) {
        customDays = index === -1 ? [dayValue] : [];
        this.isFirstCustomToggle = false;
      } else {
        if (index === -1) {
          customDays.push(dayValue);
        } else {
          customDays.splice(index, 1);
        }
      }
      this.tempSelection.customDays = customDays;
    },
    applySelection(event) {
      const dayMap = {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday'
      };

      const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

      // Always use the current temp selection
      const rawCustomDays = this.tempSelection.customDays || [];

      const uniqueCustomDays = [...new Set(
        rawCustomDays.map(day => dayMap[day.toLowerCase()] || day)
      )].sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));

      const workingDaysObject = {
        option: this.tempSelection.option,
        customDays: uniqueCustomDays
      };
-

      this.$emit('input', workingDaysObject);
      this.isOpen = false;
      this.isFirstCustomToggle = true; // you can still reset this if needed
    },
    closeCustomPopover(event) {
      if (event) event.stopPropagation();
      this.isOpen = false;
      this.tempSelection = {
        option: { ...this.value.option },
        customDays: [...(this.value.customDays || [])]
      };
      this.isFirstCustomToggle = true;
    },
    getWorkingDaysDisplay(selection) {
      const dayAbbreviations = {
        Monday: 'Mo',
        Tuesday: 'Tu',
        Wednesday: 'We',
        Thursday: 'Th',
        Friday: 'Fr',
        Saturday: 'Sa',
        Sunday: 'Su',
        monday: 'Mo',
        tuesday: 'Tu',
        wednesday: 'We',
        thursday: 'Th',
        friday: 'Fr',
        saturday: 'Sa',
        sunday: 'Su'
      };
      if (selection.option.value === 'custom') {
        if (!selection.customDays || selection.customDays.length === 0) {
          return 'None';
        }
        const selectedDays = selection.customDays
          .map(day => dayAbbreviations[day] || '')
          .filter(Boolean)
          .join(', ');
        return selectedDays;
      }
      if (selection.option.value === 'all') return 'Mo, Tu, We, Th, Fr, Sa, Su';
      if (selection.option.value === 'except-weekend') return 'Mo, Tu, We, Th, Fr';
      if (selection.option.value === 'except-sunday') return 'Mo, Tu, We, Th, Fr, Sa';
      return selection.option.label;
    },
    handleClickOutside(event) {
      const popover = this.$refs.popover;
      const dropdown = this.$refs.dropdownRoot;

      if (
        this.isOpen &&
        (!popover || !popover.contains(event.target)) &&
        !dropdown.contains(event.target)
      ) {
        this.isOpen = false;
        this.tempSelection = {
          option: { ...this.value.option },
          customDays: [...(this.value.customDays || [])]
        };
        this.isFirstCustomToggle = true;
      }
    }
  }
};
</script>

<style scoped>
.working-days-dropdown {
  position: relative;
  min-width: auto;
  width: 100%;
  outline: none;
}
.option-item{
  padding: 3px 12px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
.btn-close, .btn-apply {
  padding: 4px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 5px;
}

.btn-close {
  background-color: #ddd;
}

.btn-close:hover {
  background-color: #ccc;
}

.btn-apply {
  background-color: #435851;
  color: white;
}
.button-paraent{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.btn-apply:hover {
  background-color: #5d7974;
}

.btn-apply:disabled {
  background-color: #a5d6a7;
  cursor: not-allowed;
}

.dropdwon-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  text-align: start;
  border-radius: 10px;
}

.dropdown-button {
  text-align: left;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  outline: none;
  font-size: 13px !important;
}

.custom-input {
  margin-right: 8px;
  margin-top: -5px;
  cursor: pointer;
}

.cutom-input-container {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  margin-bottom: 8px;
}

.checkbox-columns {
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
  padding: 0px 10px;
  justify-content: space-between;
}

.checkbox-columns .cutom-input-container {
  flex: 0 0 50%;
  box-sizing: border-box;
  padding-right: 8px;
}

.popover-content-table-bottom {
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 8px;
  width: 250px;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  border-radius: 4px;
  margin-top: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.popover-content-table-top {
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 8px;
  width: 250px;
  position: absolute;
  bottom: 100%;
  left: 0;
  z-index: 10;
  border-radius: 4px;
  margin-bottom: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/WorkingDays.vue